import React, { Component } from "react";
const Loading = () => {
    return (<div className="preloader-container"><div className="loading">
      <div></div>
      <div></div>
    </div></div>)
  }
  export default Loading;